/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import Box from '@material-ui/core/Box';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { SnackbarProvider } from 'notistack';
import { CustomSwitch, CustomTable } from '../../../../components';
import useStyle from './useStyle';
import useGetProviderById from '../../../../services/providers/useGetProviderById';

const ProviderInfoFetcher = ({ provider, onResult }) => {
  const { data, error, loading } = useGetProviderById(provider.beneficiaryId, provider.serviceType);

  useEffect(() => {
    if (!loading && data && !error) {
      const providerData = data?.data?.[0];

      const row = {
        id: provider.beneficiaryId,
        name: provider.reference,
        category: providerData?.creditorAgent,
        pay_method: providerData?.supplementaryData?.[0]?.paymentMethod,
        payment: providerData?.supplementaryData?.[0]?.instructedAmount?.hasPartialPayment ? 'Si' : 'No',
        vendor: providerData?.supplementaryData?.[0]?.vendor,
        active: provider?.status,
        actions: onResult.createActions(provider.status, provider.beneficiaryId),
        state: onResult.createStatusSwitch({ ...provider, ...providerData }),
      };

      onResult.addRow(row);
    }
  }, [data, error, loading]);

  return null;
};

const ProvidersPaymentTable = (props) => {
  const classes = useStyle();
  const {
    providers, setDefaultValues, setPopUpAction, updateProvider, getProviders,
  } = props;
  const [providersRows, setProvidersRows] = useState([]);
  const providerRef = React.useRef();

  const openModalEditProvider = (bannerId) => {
    const providerEdit = providers.find((row) => row.beneficiaryId === bannerId);

    setDefaultValues({
      id: providerEdit.id,
      beneficiaryId: providerEdit.beneficiaryId,
      reference: providerEdit.reference,
      beneficiaryType: providerEdit.beneficiaryType,
      creditorAgent: providerEdit.categoryId,
      status: providerEdit?.status,
    });

    setPopUpAction({
      open: true,
      title: 'Editar proveedor',
      data: providerEdit,
    });
  };

  const createActions = (active, providerId) => (
    <Box display="flex" flexDirection="row" justifyContent="center">
      <IconButton
        edge="end"
        aria-label="Editar"
        size="small"
        onClick={() => openModalEditProvider(providerId)}
        classes={{ disabled: classes.disabled }}
      >
        <Tooltip title="Editar" placement="top">
          <EditIcon className={classes.editIcon} />
        </Tooltip>
      </IconButton>
      <IconButton
        edge="end"
        aria-label="Delete"
        size="small"
        disabled
        style={{ paddingLeft: 10 }}
        classes={{ disabled: classes.disabled }}
      >
        <Tooltip title="Eliminar" placement="top">
          <DeleteIcon className={classes.editIcon} />
        </Tooltip>
      </IconButton>
    </Box>
  );

  const updateStatus = async (item) => {
    const body = {
      id: item.id,
      beneficiaryId: item.beneficiaryId,
      status: item.status ? 0 : 1,
    };
    await updateProvider(body);
    await getProviders();
  };

  const createStatusSwitch = (provider) => (
    <Tooltip title="Cambiar estado" placement="top">
      <Box alignSelf="center">
        <CustomSwitch
          checked={provider?.status}
          handleChange={() => {}}
          onChange={() => updateStatus(provider)}
          name="active"
        />
      </Box>
    </Tooltip>
  );

  const columns = [
    { id: 'id', label: 'ID', paddingLeft: '40px', width: 150, position: 1 },
    { id: 'name', label: 'Nombre', paddingLeft: '40px', width: 150, position: 2 },
    { id: 'category', label: 'Categoría', paddingLeft: '40px', width: 150, position: 3 },
    { id: 'pay_method', label: 'Método de pago', paddingLeft: '40px', width: 10, position: 4 },
    { id: 'payment', label: 'Abono', paddingLeft: '40px', width: 10, position: 6 },
    { id: 'vendor', label: 'Agregador', paddingLeft: '40px', width: 10, position: 7 },
    { id: 'actions', paddingLeft: '', label: 'Acciones', width: 5, position: 8 },
    { id: 'state', paddingLeft: '', label: 'Estado', width: 5, position: 9 },
  ];

  const addRow = (row) => {
    setProvidersRows((prevRows) => [...prevRows, row]);
  };

  useEffect(() => {
    setProvidersRows([]); // reset al cambiar la lista
  }, [providers]);

  return (
    <SnackbarProvider ref={providerRef}>
      {providers.map((provider) => (
        <ProviderInfoFetcher
          key={provider.beneficiaryId}
          provider={provider}
          onResult={{ addRow, createActions, createStatusSwitch }}
        />
      ))}
      <CustomTable data={providersRows} columns={columns} />
    </SnackbarProvider>
  );
};

export default ProvidersPaymentTable;